import base_ds from "@/services/base_datasource_service";
import {CutType, EcoObjectType, Period, UserPreset, YearType} from '@/services/models-service';
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import _, { result } from "lodash";
import AuthService from "./auth_service";
import DictsCacheService from "@/services/dicts_cache_service";
import auth_service from "@/services/auth_service";
import EcoObjectsService from "@/services/eco-objects-service";
import UserManagerService from "@/services/data/user_manager";
import UserAccessService from "@/services/user_access_service";

export const route_ns = `preset`;

interface IExportServiceFilter {
  id_cut:string,
  id_eco_facility: number,
  id_node: number | null,
  months: string[],
  show_power: boolean,
  id_secondary_cut?: string,
  show_volume?: boolean,
  show_price?: boolean,
  show_cost?: boolean,
  show_cost_delta?: boolean,
  show_cost_total?: boolean,
  show_price_total?: boolean,
}

class PresetService {
  public crud = base_ds.getBaseCrud(route_ns);
  public auth_service = AuthService;
  public show_imbalance = false
  public currentPreset: UserPreset = new UserPreset();
  private _cache_presets: UserPreset[] = [];
  private preset_loaded: boolean = false;
  public  preset_changed: boolean = false;
  // Отображаемые месяцы с учетом времени жизни объектов ТУ
  public period_filtered: number[] = [];

  private filials_ds: EcoObjectType [] = [];
  private heat_node_ds: EcoObjectType [] = [];
  private facility_ds: EcoObjectType [] = [];

  public tableWidth: number = 120;
  public cardWidth: number = 120;
  public groupedPeriods: any[] = [];
  public uniqueMonths: any = new Set();

  // Флаг отображения мощности выставляется после первоначальной загрузки данных или после сохранения,
  // представляет состояние до внесения изменений на фронте или после сохранения изменений
  private showPowerBeforeChanges = false;

  get filials() {

    return this.filials_ds;
  }

  async getFilials(year_ds: any[], cut_ds: any[], months_list: any[]) {

    if (this.filials_ds.length > 0) {
      return this.filials_ds;
    }

    const year = this.getYear(year_ds);
    const cut = this.getCut(cut_ds);

    if(year?.name && cut?.id_eco_version && months_list.length > 0) {
      const response = await EcoObjectsService.get_filials(cut.id_eco_version, year.name, months_list);
      if (response?.data) {
        this.filials_ds = response?.data;
      }
    } else {
      this.currentPreset.id_eco_filial = null;
      this.filials_ds = [];
    }

    // // если ранее выбранный объект не попадает в новую выборку - сброс объекта
    if (!_.isNil(this.currentPreset.id_eco_filial)) {
      const obj = this.filials_ds.find((o: any) => {
        return o.id === this.currentPreset.id_eco_filial
      });

      if (!obj) {
        this.currentPreset.id_eco_filial = null
      }
    }

    return this.filials_ds;
  }

  async getHeatNodes(year_ds: any[], cut_ds: any[], months_list: any[]) {
    if (this.heat_node_ds.length > 0) {
      return this.heat_node_ds;
    }

    const year = this.getYear(year_ds);
    const cut = this.getCut(cut_ds);

    if(year?.name && cut?.id_eco_version && this.currentPreset.id_eco_filial && months_list.length > 0) {
      const response = await EcoObjectsService.get_heat_nodes(cut.id_eco_version, this.currentPreset.id_eco_filial, year.name, months_list);
      if (response?.data) {
        this.heat_node_ds = response.data;
      }
    } else {
      this.currentPreset.id_eco_heat_node = null;
      this.heat_node_ds = [];
    }

    // // если ранее выбранный объект не попадает в новую выборку - сброс объекта
    if (!_.isNil(this.currentPreset.id_eco_heat_node)) {
      const obj = this.heat_node_ds.find((o: any) => {
        return o.id === this.currentPreset.id_eco_heat_node
      });

      if (!obj) {
        this.currentPreset.id_eco_heat_node = null
      }
    }

    return this.heat_node_ds;
  }

  getYear(year_ds: any[]) {
    return year_ds.find((y:YearType) => y.id === this.currentPreset.id_year)
  }


  getCut(cut_ds: any[]) {
    return cut_ds.find((c:CutType) => c.id === this.currentPreset.id_cut);
  }

  async getFacilities(year_ds: any[], cut_ds: any[], months_list: any[], permission_nodes: any[]) {

    if (this.facility_ds.length > 0) {
      // // если ранее выбранный объект не попадает в новую выборку - сброс объекта
      if (!_.isNil(this.currentPreset.id_eco_facility)) {
        const obj = this.facility_ds.find((o: any) => {
          return o.id === this.currentPreset.id_eco_facility
        });

        if (!obj || permission_nodes.length === 0) {
          this.currentPreset.id_eco_facility = null
        }
      }
      return this.facility_ds;
    }

    const year = this.getYear(year_ds);
    const cut = this.getCut(cut_ds);

    if(year?.name && cut?.id_eco_version && this.currentPreset.id_eco_heat_node && months_list.length > 0) {
      const response = await EcoObjectsService.get_facilities(cut.id_eco_version, this.currentPreset.id_eco_heat_node, null, year.name, months_list);
      if (response?.data) {
        // Сортировка: сначала по object_type_id (по убыванию), затем по name (по возрастанию)
        this.facility_ds = response.data.slice().sort((a, b) => {
          const objTypeA = a.object_type_id ?? 0;
          const objTypeB = b.object_type_id ?? 0;
          if (objTypeA !== objTypeB) {
            return objTypeB - objTypeA; // object_type_id по убыванию
          }
          const nameA = a.name ?? '';
          const nameB = b.name ?? '';
          return nameA.localeCompare(nameB, 'ru');
        });
      }
    } else {
      this.currentPreset.id_eco_facility = null;
      this.facility_ds = [];
    }

    // // если ранее выбранный объект не попадает в новую выборку - сброс объекта
    if (!_.isNil(this.currentPreset.id_eco_facility)) {
      const obj = this.facility_ds.find((o: any) => {
        return o.id === this.currentPreset.id_eco_facility
      });

      if (!obj || permission_nodes.length === 0) {
        this.currentPreset.id_eco_facility = null
      }
    }

    return this.facility_ds;
  }

  get heat_nodes() {
    return this.heat_node_ds;
  }

  get facilities() {
    return this.facility_ds;
  }

  setFilials(data: EcoObjectType []) {
    this.filials_ds = _.clone(data)
  }

  setHeatNodes(data: EcoObjectType []) {
    this.heat_node_ds = _.clone(data)
  }

  setFacilities(data: EcoObjectType []) {
    this.facility_ds = _.clone(data)
  }

  setPowerAfterLoading(value: boolean) {
    this.showPowerBeforeChanges = value;
  }

  constructor() {
    this.loadFromLocalStorage();
  }

  async load_cache() {
    if (auth_service.getToken().length === 0) {
      return
    }

    this.resetAfterLogin();
    return Promise.resolve(this.loadPresets())
  }

  resetAfterLogin() {
    this.preset_loaded = false;
    this.preset_changed = false;
    this.filials_ds = [];
    this.heat_node_ds = [];
    this.facility_ds = [];
    this.period_filtered = [];
  }

  public loadPreset() {

    if (!this.preset_loaded) {
      this.currentPreset = new UserPreset();
      const current_id = this.auth_service.getUserIdFromToken();
      const loaded = this._cache_presets.find((preset: any) => preset.id_user === current_id);

      if (loaded) {
        this.currentPreset = _.cloneDeep(loaded);
        this.show_imbalance = this.currentPreset.show_imbalance
        if (loaded.period) {
          this.currentPreset.period = JSON.parse(loaded.period);
        }
      } else {
        this.currentPreset.id_user = current_id;
      }

      this.preset_loaded = true;
      this.preset_changed = false;
    }

  }

  public async save(entity: UserPreset): Promise<UserPreset> {
    const response = await this.crud.save(entity);
    if (response) {
      return response as unknown as UserPreset;
    } else {
      return new UserPreset();
    }
  }

  public setCurrent(preset: UserPreset) {
    this.currentPreset = _.cloneDeep(preset);
  }

  async loadPresets(): Promise<void> {
    try {
      const resp: AxiosResponse['data'] = await request({
        url: 'preset',
        method: 'get'
      });

      if (resp && resp.data) {
        this._cache_presets = _.cloneDeep(resp.data);
        localStorage.setItem('_cache_presets', JSON.stringify(this._cache_presets));
      }

      console.log('user_presets_loaded');
    } catch (e) {
      console.error(e);
    }
  }

  loadFromLocalStorage() {
    let cache = localStorage.getItem('_cache_presets');
    if (cache) {
      try {
        this._cache_presets = JSON.parse(cache);
      } catch (e) {
        this._cache_presets = [];
      }
    }
  }

  public createExportToExcelFilterObject(inputName: string = ''): IExportServiceFilter | null {
    if (this.currentPreset?.id_cut && this.currentPreset?.id_eco_facility &&
      this.currentPreset?.period?.length) {
      const filter: IExportServiceFilter = {
        id_cut: this.currentPreset?.id_cut,
        id_eco_facility: this.currentPreset?.id_eco_facility,
        months: this.currentPreset?.period,
        id_secondary_cut: this.currentPreset?.id_secondary_cut || undefined,
        id_node: this.currentPreset.id_eco_heat_node,
        show_power: inputName !== 'losses' ? this.showPowerBeforeChanges : false,

      }
      if (inputName) {
        filter.show_volume = this.currentPreset[inputName + '_show_volume' as keyof UserPreset] || false;
        filter.show_cost = this.currentPreset[inputName + '_show_cost' as keyof UserPreset] || false;
        filter.show_price = this.currentPreset[inputName + '_show_price' as keyof UserPreset] || false;
        filter.show_cost_delta = this.currentPreset[inputName + '_show_cost_delta' as keyof UserPreset] || false;
        filter.show_cost_total = this.currentPreset[inputName + '_show_cost_total' as keyof UserPreset] || false;
        filter.show_price_total = this.currentPreset[inputName + '_show_price_total' as keyof UserPreset] || false;

      }
      return filter;
    }
    return null;
  }
}

export default new PresetService();
